// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.RentalManagerZillowAccountDetailsV2WebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails,
  RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { ZillowAccountDetailsWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_Options = UseQueryOptions<
  ZillowAccountDetailsWebApiDto,
  unknown,
  ZillowAccountDetailsWebApiDto,
  readonly [string]
>;

const RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_GetKey = () =>
  [RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_Path] as const;

export const RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_GetKey(),
    queryFn: () => RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get Zillow account details for the logged-in user
 */
export const useRentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails = ({
  httpClient,
  ...options
}: Omit<RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails.getKey =
  RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_GetKey;
